import React, {useState} from "react";
import { Box, Button, TextField, Typography, Grid, Modal } from "@mui/material";
import {Formik, Field, Form, ErrorMessage} from "formik";
import * as Yup from "yup";
import {toast} from "react-toastify";
import Api from "../../api/Api";
import {Urls} from "../../api/Urls";
import FormikErrorText from "../../components/ui/FormikErrorText";
import ContentBox from "../../components/ui/ContentBox";
import ButtonSquare from "../../components/ui/ButtonSquare";
// Vous pouvez réutiliser votre style de modal déjà défini
import {modalStyle} from "../../theme/ModalStyle";

function CourtBookingCard({booking, access_token, didDelete, setDidDelete, didUpdate, setDidUpdate}) {
    // Gestion de l'ouverture des modales d'édition et de suppression
    const [openEdit, setOpenEdit] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);

    // Fonction de suppression
    const handleDelete = () => {
        Api.delete(Urls.DELETE_COURT_BOOKING + `/${booking.id}`, {
            headers: {"Content-Type": "application/json", authorization: `Bearer ${access_token}`},
        })
            .then((response) => {
                toast.success("Court booking deleted successfully");
                setDidDelete(!didDelete);
                setOpenDelete(false);
            })
            .catch((error) => {
                toast.error(error?.response?.data?.message);
            });
    };

    // Schéma de validation pour l'édition
    const editValidationSchema = Yup.object().shape({
        duration: Yup.number()
            .typeError("Duration must be a number")
            .required("Duration is required"),
        price: Yup.number()
            .typeError("Price must be a number")
            .required("Price is required"),
    });

    // Valeurs initiales pour l'édition (préremplies avec les données existantes)
    const initialValuesEdit = {
        duration: booking.duration,
        price: booking.price,
    };

    // Fonction de soumission pour l'édition
    const handleEditSubmit = (values, {resetForm}) => {
        Api.patch(Urls.UPDATE_COURT_BOOKING + `/${booking.id}`, values, {
            headers: {"Content-Type": "application/json", authorization: `Bearer ${access_token}`},
        })
            .then((response) => {
                toast.success("Court booking updated successfully");
                setDidUpdate(!didUpdate);
                setOpenEdit(false);
                resetForm();
            })
            .catch((error) => {
                toast.error(error?.response?.data?.message);
            });
    };

    return (
            <ContentBox sx={{padding: "16px", marginBottom: "16px"}}>
                {/* En-tête de la carte avec titre et boutons d'action */}
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography fontSize="18px" fontWeight="600" color="#4B465C">
                        Court Booking
                    </Typography>
                    <Box display="flex" gap="8px">
                        <ButtonSquare action="edit_outlined" onClick={() => setOpenEdit(true)}/>
                        <ButtonSquare action="delete_red" onClick={() => setOpenDelete(true)}/>
                    </Box>
                </Box>
                {/* Affichage des informations du court booking */}
                <Box marginTop="8px">
                    <Typography>Duration: {booking.duration} minutes</Typography>
                    <Typography>Price: {booking.price}</Typography>
                </Box>

                {/* Modal pour l'édition */}
                <Modal open={openEdit} onClose={() => setOpenEdit(false)}>
                    <Box sx={{...modalStyle, width: 400}}>
                        <Typography variant="h6" component="h2" marginBottom="16px">
                            Edit Court Booking
                        </Typography>
                        <Formik initialValues={initialValuesEdit} validationSchema={editValidationSchema}
                                onSubmit={handleEditSubmit}>
                            {() => (
                                <Form>
                                    <Box mb={2}>
                                        <Field name="duration" as={TextField} fullWidth label="Duration (minutes)"
                                               variant="outlined"/>
                                        <ErrorMessage name="duration" component={FormikErrorText}/>
                                    </Box>
                                    <Box mb={2}>
                                        <Field name="price" as={TextField} fullWidth label="Price" variant="outlined"/>
                                        <ErrorMessage name="price" component={FormikErrorText}/>
                                    </Box>
                                    <Box display="flex" justifyContent="flex-end" gap="8px">
                                        <Button onClick={() => setOpenEdit(false)} variant="secondary_gray">
                                            Cancel
                                        </Button>
                                        <Button type="submit" variant="primary_active">
                                            Save
                                        </Button>
                                    </Box>
                                </Form>
                            )}
                        </Formik>
                    </Box>
                </Modal>

                {/* Modal pour la suppression */}
                <Modal open={openDelete} onClose={() => setOpenDelete(false)}>
                    <Box sx={{...modalStyle, width: 400}}>
                        <Typography variant="h6" component="h2" marginBottom="16px">
                            Delete Court Booking
                        </Typography>
                        <Typography marginBottom="16px">
                            Are you sure you want to delete this court booking?
                        </Typography>
                        <Box display="flex" justifyContent="flex-end" gap="8px">
                            <Button onClick={() => setOpenDelete(false)} variant="secondary_gray">
                                Cancel
                            </Button>
                            <Button onClick={handleDelete} variant="primary_active">
                                Delete
                            </Button>
                        </Box>
                    </Box>
                </Modal>
            </ContentBox>

    );
}

export default CourtBookingCard;
